// ** React Imports
import { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'

// ** Icons Imports
import { Disc, X, Circle } from 'react-feather'

// ** Hooks
import { useApp } from '@src/utility/hooks/useApp'
import { useSkin } from '@src/utility/hooks/useSkin'

const VerticalMenuFooter = props => {
  // ** Props
  const { menuCollapsed, setMenuCollapsed, setMenuVisibility, setGroupOpen, menuHover } = props

  const { appInfo } = useApp()

  // Logos are different :: Icon is showed when collapsed, text when showed all bar
  const [source, setSource] = useState(appInfo.appFooterLogo.preview)
  const [source2, setSource2] = useState(appInfo.appFooterLogo.full ?
      appInfo.appFooterLogo.full :
      null
  )

  // ** Reset open group
  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([])
  }, [menuHover, menuCollapsed])


  return (
    <div className='navbar-footer'>
      <ul className='nav navbar-nav flex-row'>
        <li className='nav-item me-auto'>
          <NavLink to='/' className='navbar-brand'>
            {source2 ?
                <span className={`${!menuHover && menuCollapsed ? 'brand-footer-logo' : 'brand-footer-logo-full'}`}>
                {!menuHover && menuCollapsed ? <img src={source} alt='logo'/> : <img src={source2} alt='logo'/>}
                </span> :
                <span className={`brand-footer-logo`}>
                 <img src={source} alt='logo'/>
                </span>
            }
          </NavLink>
        </li>
      </ul>
    </div>
  )
}

export default VerticalMenuFooter
